const usePortfolioCalculatorStyles = () => {
  return {
    container: {
      display: 'block',
      p: 4
    },
    slidersSection: {
      spacing: 4,
      align: 'stretch'
    },
    resultsSection: {
      bg: 'gray.50',
      p: 4,
      borderRadius: 'md',
      minH: '400px'
    },
    sliderGroup: {
      mb: 6
    },
    sliderLabel: {
      fontSize: 'sm',
      fontWeight: 'bold',
      mb: 2
    },
    sliderValue: {
      fontSize: 'sm',
      color: 'gray.600'
    },
    resultHeading: {
      size: 'md',
      mb: 4
    },
    resultText: {
      fontSize: 'lg',
      fontWeight: 'bold',
      mb: 2
    },
    explanationText: {
      fontSize: 'sm',
      color: 'gray.700',
      lineHeight: 'tall'
    }
  }
}

export default usePortfolioCalculatorStyles
